<template>
	<div class="parent" style="margin:10px;">
		<table>
            <thead v-if="column_names.length==0"><tr><th>[empty table]</th></tr></thead>
			<tbody v-if="column_names.length>0">
				<tr v-for="(h) in height">
					<td v-for="(w) in width">
						<div v-if="((w-1)+(h-1)*(width))==column_names.length-1" colspan="4">

						</div>
						<div v-else>
							<p class="colname">{{column_names[(w-1)+(h-1)*(width)]}}</p>
							<p class="coldata">{{column_data[0][(w-1)+(h-1)*(width)]}}</p>
						</div>
					</td>
				</tr>
				<tr>
					<td colspan="4">
						<p class="colname">{{column_names[column_names.length-1]}}</p>
						<p class="coldata">{{column_data[0][column_data[0].length-1]}}</p>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: '',
        id: Number,
		width:Number,
		height:Number,
    },
	data() {
		return {
			column_names: [],
			column_data:[],
		}
	},
	async created () {
		this.search(true)
	},
	methods: {
        async clear (){
            this.term = "";
            this.search(true);
        },
		async search (full){
			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.id,
						fullsearch:full,
						data:[
	                        this.term
	                    ]
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
		            this.column_names = res.data.data.column_names;
					this.column_data = res.data.data.column_data;
				}
	        });
		},
        async select (index){
            api.postData(
                {
                    type:"select",
					data:{
						pageid:this.id
					}
                }
            ).then((res) => {
				if(res.data.data.to!=null)
					router.push('/'+res.data.data.to+'?q='+this.column_data[index][res.data.data.select]);
            });
        },
        async add (){
            this.redirect('040'+this.id);
        },
        async redirect(dir) {
            router.push('/'+dir);
        }
	}
}
</script>

<style scoped>
table,th,td {
	background-color: #ffffff;
	border-collapse: collapse;
	border: 0px solid black;
	empty-cells: show;
}

td{
	position:relative;
}

.colname{
	position:relative;
	padding:0px;
	margin:0px;
	font-size:10px;
	font-weight:bold;
}

.coldata{
	position:relative;
	padding:0px;
	margin:0px;
	font-size:20px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_3.vue